import _set from 'lodash/set';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { observable } from 'mobx';
import { IGuideModel, EPpGuideOrientation, IGuide } from '@src/slide/domain/ui-model/element-modeles/Interface/guide-model-v3.interface';
import { GuidePropertyConverter } from '@src/slide/domain/ui-model/converter/node-property/element/guide-property-converter';
import { ICTExtendedGuide } from '@tencent/slide-sdk-model';

export class Guide implements IGuide {
    public type = UIModelType.GUIDES;
    /**
     * 参考线方向
     */
    @observable public orient: EPpGuideOrientation;

    /**
     * 对齐线颜色
     */
    @observable public color: string;

    /**
     * 对齐线位置，沿x/y轴计算
     */
    @observable public pos: number;
}

export default class GuideModel implements IGuideModel {
    public static convertDataUiToSdk(uiData): ICTExtendedGuide[] {
        return GuidePropertyConverter.convertPartialDataFromUiToSdk(uiData || []);
    }

    public static convertDataSdkToUi(sdkData, uiData) {
        if (sdkData?.props?.slideGuideList) {
            _set(uiData, 'slideGuideList', GuidePropertyConverter.convertPartialDataFromSdkToUi(sdkData.props.slideGuideList));
        }
    }

    public slideGuideList: Array<IGuide> = [];
    public type = UIModelType.GUIDES;
    private sdkData: any;

    public async bindSDK(sdkData): Promise<void> {
        if (sdkData) {
            this.sdkData = sdkData;
            GuideModel.convertDataSdkToUi(this.sdkData, this);
        } else {
            this.unbindSDK();
        }
    }

    public unbindSDK() {
        if (this.sdkData) {
            this.sdkData = null;
        }
    }
}
